import React, { Component } from 'react';
import { useState, useEffect } from 'react';
import { basePort, headers } from "../module_auth/AuthService"
import parse from 'html-react-parser';
import {
    BrowserRouter as Router,
    useParams,
  } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { getTextWorkCity, getTextWorkTime, getTextVisaStat } from "../component/common/BaseUtil"

export function PersonHome() {
    const queryParameters = new URLSearchParams(window.location.search)
    const id = queryParameters.get("id")

    //구직상세
    const [objTitle, setObjTitle] = useState("");
    const [fullname, setFullname] = useState("");
    const [telno, setTelno] = useState("");
    const [email, setEmail] = useState("");
    const [workCity, setWorkCity] = useState("0");
    const [workTime, setWorkTime] = useState("0");
    const [visaStat, setVisaStat] = useState("");
    const [eduHist, setEduHist] = useState('');
    const [resumeHist, setResumeHist] = useState('');
    const [pvIntro, setPvIntro] = useState('');
    const [redirect, setRedirect] = useState(false);
    //End 구직상세

    useEffect(() => {
        let url = basePort + '/get/person/' + id
        fetch(url, 
          {method:'GET', headers,
            body:JSON.stringify()})
            .then(response => response.json())
            .then(response => {
                setObjTitle(response.objTitle)
                setFullname(response.fullname)
                setTelno(response.telno)
                setEmail(response.email)
                setWorkCity(response.workCity)
                setWorkTime(response.workTime)
                setVisaStat(response.visaStat)
                setEduHist(response.eduHist)
                setResumeHist(response.resumeHist)
                setPvIntro(response.pvIntro)
          }).catch(error => console.log(error))
    }, []);

    let navigate = useNavigate();    
    function backToList() {
        let page = localStorage.getItem("page")
        let pageList = page == null ? 1 : page
        let url = "/home";
        navigate(url);
    }

    return (
        <div>
            <main class="page lanidng-page">
                <section>
                    <div class="container" style={{paddingTop:'100px', marginTop: '10px', marginBottom: '10px'}}>
                        <ol class="breadcrumb">
                            <li class="breadcrumb-item"><span>인재정보</span></li>
                            <li class="breadcrumb-item"><span>인재상세</span></li>
                        </ol>
                        <div class="card">
                            <div class="card-body" style={{marginBottom: '10px'}}>
                                <h4 class="card-title" style={{fontFamily: 'Nanum Gothic', fontWeight: 'bold'}}>{objTitle}</h4>
                                <ul class="list-group">
                                    <li class="list-group-item"><span>이름: {fullname}</span></li>
                                    <li class="list-group-item"><span>연락처: {telno}</span></li>
                                    <li class="list-group-item"><span>이메일: {email}</span></li>
                                    <li class="list-group-item"><span>근무도시: {getTextWorkCity(workCity)}</span></li>
                                    <li class="list-group-item"><span>근무형태: {getTextWorkTime(workTime)}</span></li>
                                    <li class="list-group-item"><span>비자상태: {getTextVisaStat(visaStat)}</span></li>
                                </ul>
                            </div>
                        </div>
                        <div class="card">
                            <div class="card-body">
                                <h4 class="card-title" style={{fontSize: '20px', fontFamily: 'Nanum Gothic', fontWeight: 'bold'}}>학력사항</h4>
                                <p class="card-text">{parse(eduHist)}</p>
                            </div>
                        </div>
                        <div class="card">
                            <div class="card-body">
                                <h4 class="card-title" style={{fontSize: '20px', fontFamily: 'Nanum Gothic', fontWeight: 'bold'}}>&nbsp;경력사항</h4>
                                <p class="card-text">{parse(resumeHist)}</p>
                            </div>
                        </div>
                        <div class="card">
                            <div class="card-body">
                                <h4 class="card-title" style={{fontSize: '20px', fontFamily: 'Nanum Gothic', fontWeight: 'bold'}}>&nbsp;자기소개</h4>
                                <p class="card-text">{parse(pvIntro)}</p>
                            </div>
                        </div>
                </div>
                <nav class="d-flex d-md-flex justify-content-center justify-content-md-center" style={{margintop: '10px'}}>
                    <ul class="pagination">
                        <li class="page-item"><a class="page-link" onClick={backToList}>목록</a></li>
                    </ul>
                </nav>
                </section>
            </main>
        </div>
    );
}